import React from 'react';
import styled from 'styled-components';
import { node, bool, string, oneOf } from 'prop-types';
import { getSansBold } from '@bbc/psammead-styles/font-styles';
import { C_POSTBOX } from '@bbc/psammead-styles/colours';
import { GEL_SPACING } from '@bbc/gel-foundations/spacings';
import VisuallyHiddenText from '@bbc/psammead-visually-hidden-text';
var StyledSpan = /*#__PURE__*/styled.span.attrs(function (_ref) {
  var ariaHidden = _ref.ariaHidden;
  return ariaHidden && {
    'aria-hidden': 'true'
  };
}).withConfig({
  displayName: "StyledSpan",
  componentId: "sc-5gbj69-0"
})(["", " color:", ";display:inline-block;", ""], function (_ref2) {
  var service = _ref2.service;
  return getSansBold(service);
}, C_POSTBOX, function (_ref3) {
  var dir = _ref3.dir;
  return dir === 'rtl' ? "margin-left: ".concat(GEL_SPACING, ";") : "margin-right: ".concat(GEL_SPACING, ";");
});

var LiveLabel = function LiveLabel(_ref4) {
  var service = _ref4.service,
      dir = _ref4.dir,
      ariaHidden = _ref4.ariaHidden,
      liveText = _ref4.liveText,
      offScreenText = _ref4.offScreenText,
      lang = _ref4.lang,
      children = _ref4.children;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/aria-role
    React.createElement("span", {
      role: "text"
    }, /*#__PURE__*/React.createElement(StyledSpan, {
      service: service,
      dir: dir,
      ariaHidden: ariaHidden
    }, "".concat(liveText, " ")), offScreenText && /*#__PURE__*/React.createElement(VisuallyHiddenText, {
      lang: lang
    }, "".concat(offScreenText, ", ")), children)
  );
};

LiveLabel.propTypes = {
  service: string.isRequired,
  dir: oneOf(['rtl', 'ltr']),
  ariaHidden: bool,
  liveText: string,
  offScreenText: string,
  lang: string,
  children: node
};
LiveLabel.defaultProps = {
  dir: 'ltr',
  ariaHidden: false,
  liveText: 'LIVE',
  offScreenText: null,
  lang: 'en-GB',
  children: null
};
export default LiveLabel;